module.exports = __webpack_public_path__ + "img/建筑抗震信息表@3x.png";